import React from 'react'
import { List } from '@leverege/ui-elements'

import OidcItem from './OidcItem'

/**
 * @function OidcClientsList A list of oidc clients with a selection handler attached to it
 * @component 
 * @property {Object<object>} props.clients The keys are oidc client IDs and the values are the corresponding oidc client
 * @property {function} props.onClick A click handler for an oidc client item
 * @returns {element}
 */
export default function OidcClientsList( props ) {
  const { clients, selector, onSelect } = props 

  return (
    <List selector={selector} onSelect={onSelect}>
      <List.Dynamic items={Object.values( clients )} component={OidcItem} />
    </List>
  )
}
